export default {

  methods: {

    copy (source, target) {

      if (!source || !target) {
        return false
      }

      return Object.assign(target, source)
    },



    reduce (source, target) {

      if (!source || !target) {
        return false
      }

      var res = this.clone(target)

      for (var key in res) {
        if (key in source && key in target) {
          res[key] = target[key]
        } else {
          delete res[key]
        } // if
      }  // for

      return res
    },



    subset (data, key1, key2 = null) {

      if (!data) {
        return false
      }

      for (var i = 0; i < data.length; i++) {

        if (data[i].value === key1) {

          if (!key2) {
            return data[i].children
          } else {

            for (var i2 = 0; i2 < data[i].children.length; i2++) {

              if (data[i].children[i2].value === key2) {
                return data[i].children[i2].children
              }
            } // for

          }
        }
      } // for

      return []
    },



    arrayRemoveById (arr, attr, value) {

      if (!arr) {
        return null
      }

      var i = arr.length

      while (i--) {

        if (arr[i] && arr[i][attr] &&
          (typeof arr[i][attr] === 'string'
          ? arr[i][attr].endsWith(value)
          : arr[i][attr] === value
        )) {
          arr.splice(i, 1)
        }
      }

      return arr
    },



    arrayRemove (arr, index) {
      if (!arr) {
        return false
      }

      if (this.isNumber(index) && arr.length > index) {
        arr.splice(index, 1)
      }

      return arr
    },



    exists (prop, value, list) {

      if (!list || !prop || !value) {
        return false
      }

      // Find if prop already in list...
      for (let i = 0; i < list.length; i++) {
        if (list[i][prop] === value) {
          return true
        }

      } // for

      return false
    },



    findIndex (prop, value, list) {

      if (!list || !prop || !value) {
        return null
      }

      // Find if prop already in list...
      for (let i = 0; i < list.length; i++) {
        if (list[i][prop] === value) {
          return i
        }

      } // for

      return false
    },



    findByValue (arr, value) {

      if (arr && this.isArray(arr) && value) {

        for (let i = 0; i <= arr.length; i++) {
          if (arr[i] === value) {
            return {found: true, index: i}
          }

        } // for
      }

      return {found: false, index: null}
    },



    keyExists (prop, list) {

      if (!list || !prop) {
        return false
      }

      // Find if email already in list...
      for (let i = 0; i < list.length; i++) {
        if (list[i][prop]) {
          return true
        }

      } // for

      return false
    },



    /**
     * Find value in array as single value, note: if duplicate values in the children,
     * you'll get inconsient results.
     *
     * For accurate results pass an array of values to search for.
     @return value
     */
    findInList (prop, value, list, child = null) {
      if (!prop || !value || !list) {
        return null
      }

      let ret = null

      if (prop && value && list) {
        // Find if prop already in list...
        for (let i = 0; i < list.length; i++) {

          if (list[i][prop] === value) {
            ret = list[i]

          } else {

            if (child && list[i][child]) {
              return this.findInList(prop, value, list[i][child])
            }
          }  // else...if list[i][prop]

        }  // for i = 0

      }

      return ret
    },


    /**
     * Find value in array as single value, note: if duplicate values in the children,
     * you'll get inconsient results.
     *
     * For accurate results pass an array of values to search for.
     @return value
     */
    find (prop, value, list, child = null, returnProp = null) {

      if (!list || !prop || !value) {
        return null
      }

      let isArr = this.isArray(value)

      if (isArr) {
        let val = []

        let l1 = value[0] ? this.findInList(prop, value[0], list) : null

        if (l1) {
          val.push(l1[returnProp ? returnProp : prop])
        } // if l1


        for (let i = 1; i < value.length; i++) {
          value[i] = value[i].trim()

          if (l1) {
            l1 = this.findInList(prop, value[i], l1[child])

            if (l1) {
              val.push(l1[returnProp ? returnProp : prop])
            }
          }

        }  // for

        return val

      } else {

        if (child && list[child]) {
          return this.findInList(prop, value, list[child], child)
        } else {
          return this.findInList(prop, value, list, child)
        }

      } // else..if

    },



    key (prop, list) {

      if (!list || !prop) {
        return null
      }

      // Find if key already in list...
      for (var i = 0; i < list.length; i++) {
        if (list[i][prop]) {
          return list[i][prop]
        }

      } // for

      return null
    },



    // Array Remove - By John Resig (MIT Licensed)
    remove (array, from, to) {
      var rest = array.slice((to || from) + 1 || array.length)
      array.length = from < 0 ? array.length + from : from
      return array.push.apply(array, rest)
    },



    equals (a, b) {
      if (a === b) {
        return true
      }

      if (a === null || typeof a !== 'object' ||
      b === null || typeof b !== 'object') {
        return false
      }

      var aProps = 0
      var bProps = 0

      for (var prop in a) {
        aProps += 1
      } // for

      for (prop in b) {
        bProps += 1
        if (!(prop in a) || !this.equals(a[prop], b[prop])) {
          return false
        }
      } // for

      return aProps === bProps
    }

  }

}



// WEBPACK FOOTER //
// ./src/mixins/ArrayMixins.js